var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.789,
    height: 41,
    viewBox: "0 0 27.789 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 27.789,
    height: 41,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-6 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(6 -7)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M63.873,151.068H57.142a1,1,0,0,1-.994-.884h0l-2.236-18.476-.562-4.64a1,1,0,0,1,.879-1.115,1.037,1.037,0,0,1,.118-.007H73.4a1,1,0,0,1,1,1.005,1.039,1.039,0,0,1-.013.166l-1.9,15.728-.888,7.341a1,1,0,0,1-1.075.884Z",
    transform: "translate(-46.617 -110.071)",
    fill: "#cbdb3d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M32.8,102.1l.869-8.116H15.458l.461,3.81a1.088,1.088,0,1,1-2.161.255l-.6-4.975A1.09,1.09,0,0,1,14.23,91.8H34.875v0a1.125,1.125,0,0,1,.114.006,1.087,1.087,0,0,1,.966,1.2l-1,9.353.745.091a.69.69,0,0,1,.4,1.179l-2.279,2.682a.688.688,0,0,1-1.146-.151l-1.59-3.2a.687.687,0,0,1,.7-.987v0l.736.09.14.017Zm-6.429,14.753H30.88l.846-7a1.088,1.088,0,0,1,2.161.255l-.962,7.953h0a1.085,1.085,0,0,1-1.077.958H26.367v.749h0a.688.688,0,0,1-1.065.574l-2.982-1.967a.679.679,0,0,1-.207-.2.687.687,0,0,1,.2-.951l2.938-1.938a.69.69,0,0,1,1.122.539v1.028ZM14.656,105.867l.047-.006,1.477,12.2a1.088,1.088,0,0,0,1.08.96h1.924a1.089,1.089,0,0,0,0-2.178h-.96l-1.36-11.235.836-.1a.69.69,0,0,0,.406-1.177l-2.262-2.7a.688.688,0,0,0-1.147.143l-1.611,3.188a.687.687,0,0,0,.693.992v0l.736-.085Z",
    transform: "translate(-11.373 -80.233)",
    fill: "#0f783c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M56.159,6.252A5.2,5.2,0,0,1,50.109.09a5.2,5.2,0,0,1,6.05,6.162",
    transform: "translate(-43.699 -0.001)",
    fill: "#cbdb3d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M112.661,23.742a2.933,2.933,0,0,0,3.414-3.477,2.933,2.933,0,0,0-3.414,3.477",
    transform: "translate(-98.409 -17.667)",
    fill: "#cbdb3d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M13.178,60.723h12.09a1.089,1.089,0,0,1,0,2.178H1.088a1.089,1.089,0,1,1,0-2.178Z",
    transform: "translate(0.001 -53.07)",
    fill: "#0f783c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4352b53c180abd2889fd633248aa750e.svg";
export { ForwardRef as ReactComponent };